import { useToken } from "@chakra-ui/react";

export const MESSAGE_STATUSES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

export const DASHBOARD_ITEMS = [
  {
    path: "/",
    name: "شخص/ شرکت",
    url: "/user/sherkat",
    image: "../../images/dash_company.png",
  },
  {
    path: "/",
    name: "کالا/خدمات",
    url: "/user/kala",
    image: "../../images/dash_kala.png",
  },
  {
    path: "/",
    name: "طرف حساب / خریدار",
    url: "/user/tarafhesab",
    image: "../../images/dash_tarafhesab.png",
  },
  {
    path: "/",
    name: "صدور صورتحساب",
    url: "/user/sodorhesab",
    image: "../../images/dash_invoice.png",
  },
  // {
  //   path: "/",
  //   name: "گزارشات",
  //   url: "/reports",
  //   image: "../../images/dash_reports.png",
  // },
  /* {
    path: "/",
    name: "استعلام صورتحساب",
    url: "/estelam",
    image: "../../images/dash_estelam.png",
  }, */
  {
    path: "/",
    name: "مشخصات کاربری",
    url: "/user/profile",
    image: "../../images/dash_profile.png",
  },
  /* {
    path: "/",
    name: "تنظیمات",
    url: "/setting",
    image: "../../images/dash_profile.png",
  },
  {
    path: "/",
    name: "صدور گواهی CSR",
    url: "/user/sodorcsr",
    image: "../../images/dash_profile.png",
  }, */
];

/* export const STYLE_PANEL = [
  "linear-gradient(112.83deg, rgba(255,255,255,0.82) 0%, rgba(255,255,255,1) 110.84%)",
  "linear-gradient(112.83deg, rgba(53,53,53,0.95) 0%, rgba(53,53,53,1) 110.84%)",
];

export const STYLE_PANEL_SHADOW = [
  "0px 7px 23px rgba(0,0,0,0.05)",
  "0px 12px 32px rgba(0,0,0,0.35)",
]; */

export const INITIAL_PAGING_VALUES = {
  totalPages: null,
  pre_page: null,
  next_page: null,
  total: null,
  data: null,
  pageSize: 10,
  pageIndex: 1,
};

export const INITIAL_TABLE_PARAM_VALUES = {
  totalPages: null,
  pageSize: 10,
  pageIndex: 1,
  searchTerm: null,
  stuffId: null,
  sortOrder: null,
  sortField: null,
};

export const DATA_TABLE_LOCALE = {
  emptyText: "داده وجود ندارد",
};

export const STIMULSOFT_KEY =
  "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkgpgFGkUl79uxVs8X+uspx6K+tqdtOB5G1S6PFPRrlVNvMUiSiNYl724EZbrUAWwAYHlGLRbvxMviMExTh2l9xZJ2xc4K1z3ZVudRpQpuDdFq+fe0wKXSKlB6okl0hUd2ikQHfyzsAN8fJltqvGRa5LI8BFkA/f7tffwK6jzW5xYYhHxQpU3hy4fmKo/BSg6yKAoUq3yMZTG6tWeKnWcI6ftCDxEHd30EjMISNn1LCdLN0/4YmedTjM7x+0dMiI2Qif/yI+y8gmdbostOE8S2ZjrpKsgxVv2AAZPdzHEkzYSzx81RHDzZBhKRZc5mwWAmXsWBFRQol9PdSQ8BZYLqvJ4Jzrcrext+t1ZD7HE1RZPLPAqErO9eo+7Zn9Cvu5O73+b9dxhE2sRyAv9Tl1lV2WqMezWRsO55Q3LntawkPq0HvBkd9f8uVuq9zk7VKegetCDLb0wszBAs1mjWzN+ACVHiPVKIk94/QlCkj31dWCg8YTrT5btsKcLibxog7pv1+2e4yocZKWsposmcJbgG0";

export const REPORT_FILE_NAME_SORATHESAB = "{serial}_صورتحساب_شماره_سریال";